function getDigiI18n() {
    const lang = (document.documentElement.getAttribute('lang') || 'pl').split('-')[0];
    const t = {
      pl: {
        backTo: 'Wróć do ',
        configureAndBuy: 'Skonfiguruj i kup',
        addToCart: 'Dodaj do koszyka',
        removeProductConfirm: 'Czy na pewno chcesz usunąć produkt?',
        close: 'Zamknij',
        removeFromCart: 'Usuń produkt z koszyka',
        productAddedToCart: 'Produkt został dodany do koszyka',
        continueShopping: 'Kontynuuj zakupy',
        goToCart: 'Idź do koszyka',
        samplesLimitReached: 'Limit darmowych próbek został osiągnięty',
        samplesLimitMessage: 'Wybrałeś/aś <strong>maksymalną liczbę 5</strong> darmowych próbek tkanin.',
        samplesLimitNote: 'Jeśli chcesz sprawdzić inne materiały, usuń wybrane próbki z koszyka i dodaj nowe.',
        cartAddError: 'Błąd dodawania do koszyka',
        cartAddErrorAlert: 'Wystąpił błąd podczas dodawania produktu do koszyka. Spróbuj ponownie.',
        cartAddFailed: 'Nie udało się dodać produktu do koszyka',
        currencySuffix: ' zł',
        configureKeyword: 'Skonfiguruj',
        buyKeyword: 'kup',
        samplesCheckError: 'Błąd sprawdzania limitu próbek:',
        errorLabel: 'Błąd:',
        cartCountError: 'Błąd aktualizacji licznika koszyka:',
        cartUrl: '/cart',
        productSoldOut: 'Ten produkt jest niedostępny (wyprzedany).',
        cartAddSoldOutError: 'Wystąpił błąd! Spróbuj odświeżyć stronę i dodaj produkt do koszyka jeszcze raz.',
        refreshPage: 'Odśwież stronę',
      },
      en: {
        backTo: 'Back to ',
        configureAndBuy: 'Configure and buy',
        addToCart: 'Add to cart',
        removeProductConfirm: 'Are you sure you want to remove this product?',
        close: 'Close',
        removeFromCart: 'Remove from cart',
        productAddedToCart: 'Product added to cart',
        continueShopping: 'Continue shopping',
        goToCart: 'Go to cart',
        samplesLimitReached: 'Free samples limit reached',
        samplesLimitMessage: 'You have selected the <strong>maximum of 5</strong> free fabric samples.',
        samplesLimitNote: 'To try other materials, remove some samples from your cart and add new ones.',
        cartAddError: 'Error adding to cart',
        cartAddErrorAlert: 'An error occurred while adding the product to the cart. Please try again.',
        cartAddFailed: 'Failed to add product to cart',
        currencySuffix: ' PLN',
        configureKeyword: 'Configure',
        buyKeyword: 'buy',
        samplesCheckError: 'Error checking samples limit:',
        errorLabel: 'Error:',
        cartUrl: '/en/cart',
        productSoldOut: 'This product is unavailable (sold out).',
        cartAddSoldOutError: 'An error occurred! Try refreshing the page and add the product to the cart again.',
        refreshPage: 'Refresh page',
      }
    };
    return t[lang] || t.pl;
  }
  
  function handleFilterVisibility() {
    const container = document.querySelector('.digi-start-filters');
    if (!container) return;
    
    const filterGroups = Array.from(container.querySelectorAll('.collection-filters__filter-group'));
    const maxHeight = 50;
    
    function checkAndHideFilters() {
      filterGroups.forEach(group => group.style.display = '');
      
      for (let i = filterGroups.length - 1; i >= 0; i--) {
        if (container.offsetHeight <= maxHeight) {
          break;
        }
        filterGroups[i].style.display = 'none';
      }
    }
    checkAndHideFilters();
    window.addEventListener('resize', checkAndHideFilters);
    
    return true;
  }
  const observer = new MutationObserver((mutations) => {
    if (document.querySelector('.digi-start-filters')) {
      if (handleFilterVisibility()) {
        observer.disconnect();
      }
    }
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  handleFilterVisibility();
  
  
  
  
  
  document.addEventListener('DOMContentLoaded', () => { 
      function initEmblaSliders() {
          const initializedSliders = new WeakSet();
  
          function initSlider(slider) {
              if (initializedSliders.has(slider)) {
                  return;
              }
  
              const viewport = slider.querySelector('.productitem-slider__viewport');
              const container = slider.querySelector('.productitem-slider__container');
              
              if (!viewport || !container) {
                  return;
              }
  
              const slides = container.querySelectorAll('img[data-src]');
              if (slides.length <= 1) {
                  const prevBtn = slider.querySelector('.embla-prev.productitem-slider__prev');
                  const nextBtn = slider.querySelector('.embla-next.productitem-slider__next');
                  if (prevBtn) prevBtn.style.display = 'none';
                  if (nextBtn) nextBtn.style.display = 'none';
  
                  return; // Nie inicjalizuj slidera jeśli jest jeden lub mniej slajdów
              }
  
              const productItem = slider.closest('.productitem') || slider.closest('.productgrid--item');
  
              const embla = EmblaCarousel(viewport, {
                  containScroll: 'trimSnaps',
                  draggable: true,
                  loop: false,
                  align: 'start'
              });
  
              const prevBtn = slider.querySelector('.embla-prev.productitem-slider__prev');
              const nextBtn = slider.querySelector('.embla-next.productitem-slider__next');
  
              if (prevBtn) {
                  prevBtn.addEventListener('click', (e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      embla.scrollPrev();
                  });
              }
  
              if (nextBtn) {
                  nextBtn.addEventListener('click', (e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      embla.scrollNext();
                  });
              }
  
              viewport.addEventListener('mousedown', (e) => {
                  e.stopPropagation();
              });
  
              viewport.addEventListener('touchstart', (e) => {
                  e.stopPropagation();
              });
  
              const loadSlide = (index) => {
                  const img = slides[index];
                  if (img && img.dataset.src) {
                      img.src = img.dataset.src;
                      img.removeAttribute('data-src');
                  }
              };
  
              const loadAllSlides = () => {
                  slides.forEach((img) => {
                      if (img.dataset.src) {
                          img.src = img.dataset.src;
                          img.removeAttribute('data-src');
                      }
                  });
              };
  
              if (slides.length > 0) {
                  loadSlide(0);
              }
  
              if (productItem) {
                  let hoverTimeout;
                  
                  productItem.addEventListener('mouseenter', () => {
                      hoverTimeout = setTimeout(() => {
                          loadAllSlides();
                      }, 100);
                  });
  
                  productItem.addEventListener('mouseleave', () => {
                      clearTimeout(hoverTimeout);
                  });
              }
  
              embla.on('select', () => {
                  loadSlide(embla.selectedScrollSnap());
              });
              initializedSliders.add(slider);
          }
  
          const sliders = document.querySelectorAll('.productitem__image-container[data-embla]');
          sliders.forEach(slider => {
              initSlider(slider);
          });
      }
      initEmblaSliders();
      const emblaObserver = new MutationObserver((mutations) => {
          let shouldCheck = false;
  
          mutations.forEach((mutation) => {
              if (mutation.addedNodes.length > 0) {
                  mutation.addedNodes.forEach((node) => {
                      if (node.nodeType === 1) {
                          if (node.matches && node.matches('.productitem__image-container[data-embla]')) {
                              shouldCheck = true;
                          } else if (node.querySelector && node.querySelector('.productitem__image-container[data-embla]')) {
                              shouldCheck = true;
                          }
                      }
                  });
              }
          });
  
          if (shouldCheck) {
              setTimeout(initEmblaSliders, 100);
          }
      });
      emblaObserver.observe(document.body, {
          childList: true,
          subtree: true
      });
  
  
  
  
      //Header
      const BACKDROP_CLASS = 'backdrop-background';
      const updateBackdrop = () => {
          const details = document.querySelectorAll('ul.navmenu-depth-1 > li > details');
          const anyOpen = Array.from(details).some(d => d.hasAttribute('open'));
          let backdrop = document.querySelector(`.${BACKDROP_CLASS}`);
  
          if (anyOpen) {
              if (!backdrop) {
                  backdrop = document.createElement('div');
                  backdrop.className = BACKDROP_CLASS;
                  document.body.appendChild(backdrop);
  
                  backdrop.addEventListener('click', () => {
                      details.forEach(d => d.removeAttribute('open'));
                      updateBackdrop();
                  });
              }
          } else {
              if (backdrop) backdrop.remove();
          }
      };
  
      const observeDetails = d => {
          const observer = new MutationObserver(mutations => {
          mutations.forEach(mutation => {
              if (mutation.attributeName === 'open') updateBackdrop();
          });
          });
          observer.observe(d, { attributes: true });
      };
  
      const menuObserver = new MutationObserver(mutations => {
          mutations.forEach(mutation => {
          mutation.addedNodes.forEach(node => {
              if (node.nodeType !== 1) return;
              if (node.matches && node.matches('ul.navmenu-depth-1 > li > details')) {
                  observeDetails(node);
                  updateBackdrop();
              }
              node.querySelectorAll && node.querySelectorAll('ul.navmenu-depth-1 > li > details').forEach(d => {
                  observeDetails(d);
                  updateBackdrop();
              });
          });
          });
      });
  
      menuObserver.observe(document.body, { childList: true, subtree: true });
      document.querySelectorAll('ul.navmenu-depth-1 > li > details').forEach(d => observeDetails(d));
      updateBackdrop();
  
  
  
  
      //Update item navs
      const updateNavItems = (item) => {
          if (!item) return;
  
          const details = item.closest('details');
          if (!details) return;
  
          const summary = details.querySelector('summary');
          if (!summary) return;
  
          const text = summary.textContent.trim().toLowerCase();
          const href = summary.getAttribute('data-href');
  
          const link = item.querySelector('a');
          const span = link ? link.querySelector('span') : null;
  
          if (link) link.setAttribute('href', href || '#');
          if (span) span.textContent = text || '';
      };
  
      const processExisting = () => {
          document.querySelectorAll('.navmenu-item-collection-link').forEach(updateNavItems);
      };
  
      processExisting();
      const observer = new MutationObserver((mutations) => {
          mutations.forEach(mutation => {
              mutation.addedNodes.forEach(node => {
                  if (node.nodeType !== 1) return;
                  if (node.matches('.navmenu-item-collection-link')) {
                      updateNavItems(node);
                  }
                  node.querySelectorAll && node.querySelectorAll('.navmenu-item-collection-link').forEach(updateNavItems);
              });
          });
      });
  
      observer.observe(document.body, { childList: true, subtree: true });
  
  
  
  
  
  
  
      //Filters
      const filtersContainer = document.querySelector('.digi-start-filters');
      if (filtersContainer) {
          function removeAllActive() {
              const allHeadings = filtersContainer.querySelectorAll('.collection-filters__filter-group-heading');
              const allFilterLists = filtersContainer.querySelectorAll('ul.collection-filters__filter-list');
              const allPriceRangeForms = filtersContainer.querySelectorAll('.collection-filters__price-range-form');
              
              allHeadings.forEach(function(h) {
                  h.classList.remove('active');
              });
              
              allFilterLists.forEach(function(list) {
                  list.classList.remove('active');
              });
          
              allPriceRangeForms.forEach(function(form) {
                  form.classList.remove('active');
              });
          }
          
          filtersContainer.addEventListener('click', function(e) {
              const heading = e.target.closest('.collection-filters__filter-group-heading');
              
              if (heading) {
                  e.stopPropagation();
                  
                  const parent = heading.closest('.collection-filters__filter-group');
                  const isActive = heading.classList.contains('active');
                  
                  removeAllActive();
                  
                  if (!isActive) {
                      heading.classList.add('active');
                      
                      if (parent) {
                          const filterList = parent.querySelector('ul.collection-filters__filter-list');
                          const priceRangeForm = parent.querySelector('.collection-filters__price-range-form');
                          
                          if (filterList) {
                              filterList.classList.add('active');
                          }
                          
                          if (priceRangeForm) {
                              priceRangeForm.classList.add('active');
                          }
                      }
                  }
              }
          });
          
          document.addEventListener('click', function(e) {
              if (!filtersContainer.contains(e.target)) {
                  removeAllActive();
              }
          });
          
          filtersContainer.addEventListener('click', function(e) {
              const activeGroup = e.target.closest('.collection-filters__filter-group');
              if (activeGroup) {
                  const activeHeading = activeGroup.querySelector('.collection-filters__filter-group-heading.active');
                  if (activeHeading) {
                      e.stopPropagation();
                  }
              }
          });
      }
  
  
  
      const showAllFiltersBtn = document.querySelector('.show-all-filters');
      const sidebar = document.querySelector('.digi-collection-filers-sidebar');
      const sidebarTitle = document.querySelector('.digi-collection-filers-sidebar .productgrid--sidebar-title');
      let backdrop = null;
      let closeBtn = null;
  
      function removeActive() {
          sidebar.classList.remove('active');
          document.body.classList.remove('no-scroll');
          
          if (backdrop) {
              backdrop.remove();
              backdrop = null;
          }
          
          if (closeBtn) {
              closeBtn.remove();
              closeBtn = null;
          }
      }
  
      if (showAllFiltersBtn && sidebar) {
          showAllFiltersBtn.addEventListener('click', function(e) {
              e.preventDefault();
              
              sidebar.classList.add('active');
              document.body.classList.add('no-scroll');
              
              if (!backdrop) {
                  backdrop = document.createElement('div');
                  backdrop.className = 'backdrop-background bd-bg-filters';
                  backdrop.style.zIndex = '1200';
                  document.body.appendChild(backdrop);
                  
                  backdrop.addEventListener('click', removeActive);
              }
              
              if (!closeBtn && sidebarTitle) {
                  closeBtn = document.createElement('button');
                  closeBtn.className = 'digi-close-filters';
                  closeBtn.style.cursor = 'pointer';
                  closeBtn.addEventListener('click', removeActive);
                  sidebarTitle.appendChild(closeBtn);
              }
          });
      }
  
      document.addEventListener('click', function(e) {
          if (e.target.classList.contains('bd-bg-filters')) {
              if (sidebar) {
                  removeActive();
              }
          }
      });
  
  
  
  
  
      function initFilterRangeValidation() {
          let filterGroups = document.querySelectorAll('[data-filter-group-range]');
          
          filterGroups.forEach(function(group) {
              let inputFrom = group.querySelector('.collection-filters__filter-range--from input[data-filter-range]');
              let inputTo = group.querySelector('.collection-filters__filter-range--to input[data-filter-range]');
              
              if (!inputFrom || !inputTo) return;
              
              let rangeMin = Math.round(parseFloat(inputFrom.getAttribute('min')) || 0);
              let rangeMax = Math.round(parseFloat(inputTo.getAttribute('max')) || 100);
              
              function validateInput(input) {
              let value = input.value.replace(/\s/g, '').replace(/,/g, '').replace(/\./g, '');
              let max = Math.round(parseFloat(input.getAttribute('max')));
              let min = Math.round(parseFloat(input.getAttribute('min')) || 0);
              let numValue = Math.round(parseFloat(value));
              
              if (value === '' || isNaN(numValue)) {
                  return;
              }
              
              if (!isNaN(max) && numValue > max) {
                  input.value = max;
              } else if (!isNaN(min) && numValue < min) {
                  input.value = min;
              } else {
                  input.value = numValue;
              }
              }
              
              [inputFrom, inputTo].forEach(function(input) {
              input.addEventListener('input', function() {
                  let value = this.value.replace(/\s/g, '').replace(/,/g, '').replace(/\./g, '');
                  if (value !== this.value) {
                  this.value = value;
                  }
                  updateSliderFromInputs();
              });
              
              input.addEventListener('blur', function() {
                  validateInput(this);
                  updateSliderFromInputs();
              });
              
              input.addEventListener('change', function() {
                  validateInput(this);
                  updateSliderFromInputs();
              });
              
              input.addEventListener('keydown', function(e) {
                  if (e.key === 'Enter') {
                  validateInput(this);
                  updateSliderFromInputs();
                  }
              });
              });
              
              let slider = document.createElement('div');
              slider.className = 'filter-range-slider';
              
              let track = document.createElement('div');
              track.className = 'filter-range-slider__track';
              
              let progress = document.createElement('div');
              progress.className = 'filter-range-slider__progress';
              
              let sliderMin = document.createElement('input');
              sliderMin.type = 'range';
              sliderMin.className = 'filter-range-slider__input filter-range-slider__input--min';
              sliderMin.min = rangeMin;
              sliderMin.max = rangeMax;
              sliderMin.value = inputFrom.value || rangeMin;
              
              let sliderMax = document.createElement('input');
              sliderMax.type = 'range';
              sliderMax.className = 'filter-range-slider__input filter-range-slider__input--max';
              sliderMax.min = rangeMin;
              sliderMax.max = rangeMax;
              sliderMax.value = inputTo.value || rangeMax;
              
              slider.appendChild(track);
              slider.appendChild(progress);
              slider.appendChild(sliderMin);
              slider.appendChild(sliderMax);
              
              group.after(slider);
              
              function updateProgress() {
              let minVal = parseInt(sliderMin.value);
              let maxVal = parseInt(sliderMax.value);
              let range = rangeMax - rangeMin;
              
              let leftPercent = ((minVal - rangeMin) / range) * 100;
              let rightPercent = ((maxVal - rangeMin) / range) * 100;
              
              progress.style.left = leftPercent + '%';
              progress.style.width = (rightPercent - leftPercent) + '%';
              }
              
              function updateSliderFromInputs() {
              let fromVal = parseInt(inputFrom.value.replace(/\s/g, '').replace(/,/g, '').replace(/\./g, '')) || rangeMin;
              let toVal = parseInt(inputTo.value.replace(/\s/g, '').replace(/,/g, '').replace(/\./g, '')) || rangeMax;
              
              fromVal = Math.max(rangeMin, Math.min(rangeMax, fromVal));
              toVal = Math.max(rangeMin, Math.min(rangeMax, toVal));
              
              sliderMin.value = fromVal;
              sliderMax.value = toVal;
              updateProgress();
              }
              
              sliderMin.addEventListener('input', function() {
              let minVal = parseInt(this.value);
              let maxVal = parseInt(sliderMax.value);
              
              if (minVal > maxVal) {
                  this.value = maxVal;
                  minVal = maxVal;
              }
              
              inputFrom.value = minVal;
              inputFrom.dispatchEvent(new Event('input', { bubbles: true }));
              inputFrom.dispatchEvent(new Event('change', { bubbles: true }));
              updateProgress();
              });
              
              sliderMax.addEventListener('input', function() {
              let minVal = parseInt(sliderMin.value);
              let maxVal = parseInt(this.value);
              
              if (maxVal < minVal) {
                  this.value = minVal;
                  maxVal = minVal;
              }
              
              inputTo.value = maxVal;
              inputTo.dispatchEvent(new Event('input', { bubbles: true }));
              inputTo.dispatchEvent(new Event('change', { bubbles: true }));
              updateProgress();
              });
              
              updateSliderFromInputs();
          });
      }
      initFilterRangeValidation();
  
  
      //Listing collection
      async function digiAddToCart(variantId, button) {
          let originalText = button.textContent || button.innerHTML;
          let isIconButton = button.classList.contains('add-to-cart');
  
          button.disabled = true;
          button.classList.add('is-loading');

          const productItem = button.closest('[data-product-item]');
          const popup = button.closest('.probki-tkanin-popup');
          const isAvailable = button.dataset.productAvailable !== 'false' &&
              button.dataset.productAvailable !== '0' &&
              !productItem?.hasAttribute('data-product-not-available') &&
              !(popup && (popup.dataset.productAvailable === 'false' || popup.dataset.productAvailable === '0'));

          if (!isAvailable) {
              button.disabled = false;
              button.classList.remove('is-loading');
              if (typeof getDigiI18n().productSoldOut === 'string') {
                  alert(getDigiI18n().productSoldOut);
              }
              return;
          }

          try {
              const isSample = button.dataset.isSample === 'true';
  
              if (isSample) {
                  const samplesCount = await CartAddModal.checkSamplesLimit();
  
                  if (samplesCount >= 5) {
                      CartAddModal.showLimitModal();
                      button.disabled = false;
                      button.classList.remove('is-loading');
                      return;
                  }
              }
  
              const payload = {
                  id: variantId,
                  quantity: 1
              };
  
              if (isSample) {
                  payload.properties = { _is_sample: 'true' };
              }
  
              const response = await fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                  },
                  body: JSON.stringify(payload)
              });
  
              if (!response.ok) {
                  throw new Error(getDigiI18n().cartAddError);
              }
  
              const data = await response.json();
  
              button.classList.remove('is-loading');
              button.classList.add('is-added');
  
              const cartRes = await fetch('/cart.js');
              const cart = await cartRes.json();
  
              let headerCartCount = document.querySelector('.site-header-cart--count');
              if (headerCartCount) {
              headerCartCount.setAttribute('data-header-cart-count', cart.item_count);
                  headerCartCount.classList.add('visible');
              }
  
              let cartCounts = document.querySelectorAll('[data-cart-count], .cart-count, .site-header-cart--count span');
                  cartCounts.forEach(function(el) {
                  el.textContent = cart.item_count;
              });
  
              setTimeout(function() {
                  button.disabled = false;
                  button.classList.remove('is-added');
              }, 2000);
  
          } catch (error) {
              console.error('Add to cart error:', error);
              button.classList.remove('is-loading');
              button.classList.add('is-error');
  
              setTimeout(function() {
                  button.disabled = false;
                  button.classList.remove('is-error');
              }, 2000);
          }
      }
      
      function transformParamsTable() {
          let tables = document.querySelectorAll('.probki-tkanin-popup__params-table');
          tables.forEach(function(container) {
          let rows = container.querySelectorAll('table tr');
          if (rows.length === 0) return;
  
          let grid = document.createElement('div');
          grid.className = 'probki-tkanin-popup__params-grid';
  
          rows.forEach(function(row) {
              let cells = row.querySelectorAll('td');
              if (cells.length >= 2) {
              let param = document.createElement('div');
              param.className = 'probki-tkanin-popup__param';
  
              let label = document.createElement('span');
              label.className = 'probki-tkanin-popup__param-label';
              label.textContent = cells[0].textContent.trim();
  
              let value = document.createElement('span');
              value.className = 'probki-tkanin-popup__param-value';
              value.innerHTML = cells[1].innerHTML;
  
              param.appendChild(label);
              param.appendChild(value);
              grid.appendChild(param);
              }
          });
  
          container.innerHTML = '';
          container.appendChild(grid);
          });
      }
      function initProbkiTkaninPopup() {
          transformParamsTable();
  
          let popups = document.querySelectorAll('.probki-tkanin-popup');
          popups.forEach(function(popup) {
              document.body.appendChild(popup);
          });
  
          document.addEventListener('click', function(e) {
              // Add to cart buttons
              let addToCartBtn = e.target.closest('.add-to-cart, .probki-tkanin-popup__add-to-cart');
              if (addToCartBtn) {
                  e.preventDefault();
                  let variantId = addToCartBtn.getAttribute('data-variant-id');
                  if (variantId) {
                      digiAddToCart(variantId, addToCartBtn);
                  }
                  return;
              }
  
              let openBtn = e.target.closest('[data-probki-popup-open]');
              if (openBtn) {
                  e.preventDefault();
                  let productId = openBtn.getAttribute('data-product-id');
                  let popup = document.querySelector('[data-probki-popup="' + productId + '"]');
                  if (popup) {
                      popup.setAttribute('aria-hidden', 'false');
                      document.body.classList.add('probki-popup-open');
                  }
              }
  
              let closeBtn = e.target.closest('[data-probki-popup-close]');
              if (closeBtn) {
                  let popup = closeBtn.closest('.probki-tkanin-popup');
                  if (popup) {
                      popup.setAttribute('aria-hidden', 'true');
                      document.body.classList.remove('probki-popup-open');
                  }
              }
          });
  
          document.addEventListener('keydown', function(e) {
              if (e.key === 'Escape') {
                  let openPopup = document.querySelector('.probki-tkanin-popup[aria-hidden="false"]');
                  if (openPopup) {
                      openPopup.setAttribute('aria-hidden', 'true');
                      document.body.classList.remove('probki-popup-open');
                  }
              }
          });
      }
      initProbkiTkaninPopup();
  
      function initProbkiGslide() {
          if (typeof GLightbox === 'undefined') return;
  
          GLightbox({
              selector: '.probki-tkanin-popup__zoom'
          });
      }
      initProbkiGslide();
  
      function initCollectionChildren(navSelector = '.site-navigation-wrapper', targetSelector = '[data-collection-children]') {
          let navRoot = document.querySelector(navSelector);
          if (!navRoot) return;
  
          let currentPath = window.location.pathname.replace(/\/+$/, '');
          if (!currentPath) return;
  
          function normalizePath(href) {
              function removePolishChars(str) {
                  const polishMap = {
                      'ą': 'a', 'ć': 'c', 'ę': 'e', 'ł': 'l', 'ń': 'n',
                      'ó': 'o', 'ś': 's', 'ź': 'z', 'ż': 'z',
                      'Ą': 'A', 'Ć': 'C', 'Ę': 'E', 'Ł': 'L', 'Ń': 'N',
                      'Ó': 'O', 'Ś': 'S', 'Ź': 'Z', 'Ż': 'Z'
                  };
                  return str.replace(/[ąćęłńóśźżĄĆĘŁŃÓŚŹŻ]/g, function(match) {
                      return polishMap[match] || match;
                  });
              }
              
              try {
                  let url = new URL(href, window.location.origin);
                  let path = url.pathname.replace(/\/+$/, '');
                  try {
                      path = decodeURIComponent(path);
                  } catch (e) {
                      // ignore
                  }
                  return removePolishChars(path.toLowerCase());
              } catch (e) {
                  let path = href.split('?')[0].split('#')[0].replace(/\/+$/, '');
                  try {
                      path = decodeURIComponent(path);
                  } catch (e2) {
                      // ignore
                  }
                  return removePolishChars(path.toLowerCase());
              }
          }
  
          let currentLink = null;
          
          let allLinks = navRoot.querySelectorAll('.navmenu a[href*="/collections/"]');
          for (let link of allLinks) {
              if (link.closest('.navmenu-item-collection-link')) {
                  continue;
              }
              let linkPath = normalizePath(link.getAttribute('href'));
              if (linkPath === currentPath) {
                  currentLink = link;
                  break;
              }
          }
          
          if (!currentLink) {
              let allSummaries = navRoot.querySelectorAll('.navmenu summary[data-href*="/collections/"]');
              for (let summary of allSummaries) {
                  let linkPath = normalizePath(summary.getAttribute('data-href'));
                  if (linkPath === currentPath) {
                      currentLink = summary;
                      break;
                  }
              }
          }
  
          if (!currentLink) return;
  
          let wrapper = document.querySelector(targetSelector);
          if (!wrapper) return;
  
          function createCollectionCard(href, title, imageUrl) {
              let card = document.createElement('a');
              card.className = 'collection-child-card';
              card.href = href;
  
              let imgWrapper = document.createElement('div');
              imgWrapper.className = 'collection-child-card__image-wrapper';
  
              if (imageUrl) {
                  let img = document.createElement('img');
                  img.src = imageUrl;
                  img.alt = title;
                  img.loading = 'lazy';
                  imgWrapper.appendChild(img);
              }
  
              let titleEl = document.createElement('div');
              titleEl.className = 'collection-child-card__title';
              titleEl.textContent = title;
  
              card.appendChild(imgWrapper);
              card.appendChild(titleEl);
  
              return card;
          }
  
          if (currentLink.classList.contains('navmenu-link-depth-1')) {
              let parentLi = currentLink.closest('li.navmenu-item-parent');
              if (!parentLi) return;
  
              let depth2Menu = parentLi.querySelector('ul.navmenu-depth-2');
              if (!depth2Menu) return;
  
              let section = document.createElement('section');
              section.className = 'collection-children-section';
  
              let grid = document.createElement('div');
              grid.className = 'collection-children-grid';
  
              let depth2Links = depth2Menu.querySelectorAll('a.navmenu-link-depth-2');
              if (depth2Links.length > 0) {
                  let collectionImagesMap = {};
                  try {
                      let imagesData = wrapper.getAttribute('data-collection-images');
                      if (imagesData) {
                          collectionImagesMap = JSON.parse(imagesData);
                      }
                  } catch (e) {
                      console.error('Error parsing collection images:', e);
                  }
                  
                  depth2Links.forEach(function (childLink) {
                      let title = childLink.textContent.trim();
                      let href = childLink.getAttribute('href');
                      let normalizedHref = normalizePath(href);
                      
                      let collectionHandle = '';
                      let match = normalizedHref.match(/\/collections\/([^\/]+)/);
                      if (match) {
                          collectionHandle = match[1];
                      }
                      
                      let collectionKey = '/collections/' + collectionHandle;
                      let imageUrl = collectionImagesMap[collectionKey] || '';
                      grid.appendChild(createCollectionCard(href, title, imageUrl));
                  });
              } else {
                  let absoluteCardsContainer = depth2Menu.querySelector('.navmenu-item-absolute-collection .collection-cards-container');
                  if (absoluteCardsContainer) {
                      absoluteCardsContainer.querySelectorAll('.collection-card a').forEach(function (cardLink) {
                          let title = cardLink.querySelector('span') ? cardLink.querySelector('span').textContent.trim() : cardLink.textContent.trim();
                          let imgEl = cardLink.querySelector('img');
                          let imgSrc = imgEl ? imgEl.getAttribute('src') : '';
                          grid.appendChild(createCollectionCard(cardLink.href, title, imgSrc));
                      });
                  }
              }
  
              if (grid.children.length) {
                  section.appendChild(grid);
                  wrapper.appendChild(section);
              }
  
              return;
          }
  
          if (currentLink.classList.contains('navmenu-link-depth-2')) {
              let childParentLi = currentLink.closest('li.navmenu-item-parent');
              if (!childParentLi) return;
  
              let summary = childParentLi.querySelector('summary.navmenu-link-parent');
              let parentName = summary ? summary.textContent.trim() : '';
  
              let parentHref = '';
  
              let seeAllLink = childParentLi.querySelector('.navmenu-item-collection-link a[href*="/collections/"]');
              if (seeAllLink) {
                  parentHref = seeAllLink.getAttribute('href');
              }
  
              if (!parentHref && summary && summary.dataset.href) {
                  parentHref = summary.dataset.href;
              }
  
              if (!parentHref) {
                  let topLink = childParentLi.querySelector('.navmenu-link-depth-1[href*="/collections/"]');
                  if (topLink) {
                      parentHref = topLink.getAttribute('href');
                  }
              }
  
              if (!parentHref || !parentName) return;
  
              let backWrapper = document.createElement('div');
              backWrapper.className = 'collection-back-to-parent';
  
              let backLink = document.createElement('a');
              backLink.className = 'collection-back-to-parent__link';
              backLink.href = parentHref;
              backLink.textContent = getDigiI18n().backTo + parentName;
  
              backWrapper.appendChild(backLink);
              wrapper.appendChild(backWrapper);
          }
      }
      initCollectionChildren();
  
      //Product page
      const wishlistButton = document.querySelector('.form-configurator-main-button-row #add-to-wishlist');
      if(wishlistButton) {
          wishlistButton.addEventListener('click', async function(e) {
              //console.log('windowWishlistHash')
          });
      }
  
  
      function initStickyBar() {
          const hasConfigurator = document.querySelector('.product-main .form-configurator');
          const hasAtcButton = document.querySelector('.product-main .product-form--atc-button');
          
          if (!hasConfigurator && !hasAtcButton) return;
  
          const title = document.querySelector('h2.product-title')?.textContent?.trim() || '';
          const delivery = document.querySelector('.product-usp-section .product-usp-item:first-child .product-usp-item__title')?.textContent?.trim() || '';
          const price = document.querySelector('.product-pricing > .price.product__price')?.innerHTML || '';
          const i18n = getDigiI18n();
          const buttonText = hasConfigurator ? '<span class="box-icon"></span><span>' + i18n.configureAndBuy + '</span>' : '<span>' + i18n.addToCart + '</span>';
  
          const stickyBar = document.createElement('div');
          stickyBar.className = 'product-sticky-bar';
          stickyBar.innerHTML = `
              <div class="p-sticky-left">
              <div class="p-title">${title}</div>
              <div class="p-delivery">${delivery}</div>
              </div>
              <div class="p-sticky-right">
              <div class="p-price">${price}</div>
              <button class="btn-primary">${buttonText}</button>
              </div>
          `;
          document.body.appendChild(stickyBar);
  
          const stickyButton = stickyBar.querySelector('.btn-primary');
          let originalButton = null;
          
          if (hasConfigurator) {
              originalButton = document.querySelector('.product-main .form-configurator button[type="submit"]') || 
                             document.querySelector('.product-main .form-configurator .btn-primary');
              
              if (!originalButton) {
                  const buttons = document.querySelectorAll('.product-main .form-configurator button');
                  originalButton = Array.from(buttons).find(btn => {
                      const t = getDigiI18n();
                      return btn.textContent.trim().includes(t.configureKeyword) ||
                          btn.textContent.trim().includes(t.buyKeyword);
                  });
              }
          } else if (hasAtcButton) {
              originalButton = document.querySelector('.product-main .product-form--atc-button');
          }
          
          if (stickyButton && originalButton) {
              stickyButton.addEventListener('click', (e) => {
                  e.preventDefault();
                  originalButton.click();
              });
          }
      }
      function initScrollDetection() {
          let formConfigurator = document.querySelector('.product-main .form-configurator');
          if(!formConfigurator) {
              formConfigurator = document.querySelector('.product-main .product-form--regular');
          }
          
          if (!formConfigurator) return;
  
          const htmlElement = document.documentElement;
          
          function checkScroll() {
              const formRect = formConfigurator.getBoundingClientRect();
              
              if (formRect.bottom < 0) {
                  htmlElement.classList.add('product-page-scroll-below-form');
              } else {
                  htmlElement.classList.remove('product-page-scroll-below-form');
              }
          }
          
          window.addEventListener('scroll', checkScroll, { passive: true });
          checkScroll();
      }
      initScrollDetection();
      initStickyBar();
  
  
  
  
  
  
      //Cart
      function initCartRemoveModal() {
          let modal = null;
          let currentRemoveUrl = null;
  
          function createModal() {
              if (document.getElementById('cart-remove-modal')) {
                  return document.getElementById('cart-remove-modal');
              }
  
              const i18n = getDigiI18n();
              const modalHTML = `
                  <div id="cart-remove-modal" class="cart-remove-modal">
                      <div class="cart-remove-modal__overlay"></div>
                      <div class="cart-remove-modal__content">
                          <h3 class="cart-remove-modal__title title-mobile">${i18n.removeProductConfirm}</h3>
  
                          <button class="cart-remove-modal__close" aria-label="${i18n.close}">
                              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                  <path d="M6.70757 5.29341C6.51897 5.11125 6.26636 5.01045 6.00417 5.01273C5.74197 5.01501 5.49116 5.12018 5.30575 5.30559C5.12034 5.491 5.01517 5.74181 5.0129 6.00401C5.01062 6.2662 5.11141 6.5188 5.29357 6.70741L10.5866 12.0004L5.29357 17.2934C5.19806 17.3857 5.12188 17.496 5.06947 17.618C5.01706 17.74 4.98947 17.8712 4.98832 18.004C4.98717 18.1368 5.01247 18.2685 5.06275 18.3914C5.11303 18.5143 5.18728 18.6259 5.28117 18.7198C5.37507 18.8137 5.48672 18.8879 5.60962 18.9382C5.73251 18.9885 5.86419 19.0138 5.99697 19.0127C6.12975 19.0115 6.26097 18.9839 6.38297 18.9315C6.50498 18.8791 6.61532 18.8029 6.70757 18.7074L12.0006 13.4144L17.2936 18.7074C17.4822 18.8896 17.7348 18.9904 17.997 18.9881C18.2592 18.9858 18.51 18.8806 18.6954 18.6952C18.8808 18.5098 18.986 18.259 18.9882 17.9968C18.9905 17.7346 18.8897 17.482 18.7076 17.2934L13.4146 12.0004L18.7076 6.70741C18.8897 6.5188 18.9905 6.2662 18.9882 6.00401C18.986 5.74181 18.8808 5.491 18.6954 5.30559C18.51 5.12018 18.2592 5.01501 17.997 5.01273C17.7348 5.01045 17.4822 5.11125 17.2936 5.29341L12.0006 10.5864L6.70757 5.29341Z" fill="#222222"/>
                              </svg>
                          </button>
                          
                          <div class="cart-remove-modal__product">
                              <div class="cart-remove-modal__image">
                                  <img src="" alt="">
                              </div>
                              <div class="cart-remove-modal__details">
                                  <h3 class="cart-remove-modal__title">${i18n.removeProductConfirm}</h3>
                                  <h4 class="cart-remove-modal__product-name"></h4>
                                  <p class="cart-remove-modal__price"></p>
                                  <div class="cart-remove-modal__options"></div>
                                  <button class="cart-remove-modal__confirm">${i18n.removeFromCart}</button>
                              </div>
                          </div>
                      </div>
                  </div>
              `;
  
              document.body.insertAdjacentHTML('beforeend', modalHTML);
              
              const newModal = document.getElementById('cart-remove-modal');
              
              newModal.querySelector('.cart-remove-modal__close').addEventListener('click', closeModal);
              newModal.querySelector('.cart-remove-modal__overlay').addEventListener('click', closeModal);
              newModal.querySelector('.cart-remove-modal__confirm').addEventListener('click', function() {
                  if (currentRemoveUrl) {
                      window.location.href = currentRemoveUrl;
                  }
              });
  
              return newModal;
          }
  
          function openModal(cartItem, removeUrl) {
              modal = createModal();
              currentRemoveUrl = removeUrl;
  
              const image = cartItem.querySelector('.cart-item--image-wrapper img');
              const title = cartItem.querySelector('.cart-item--content-title a');
              const price = cartItem.querySelector('.cart-item__total .money');
              const options = cartItem.querySelectorAll('.cart-item-product-options__option');
  
              const modalImage = modal.querySelector('.cart-remove-modal__image img');
              const modalProductName = modal.querySelector('.cart-remove-modal__product-name');
              const modalPrice = modal.querySelector('.cart-remove-modal__price');
              const modalOptions = modal.querySelector('.cart-remove-modal__options');
  
              if (image) {
                  modalImage.src = image.src;
                  modalImage.alt = image.alt || '';
              }
              
              modalProductName.textContent = title ? title.textContent.trim() : '';
              modalPrice.textContent = price ? price.textContent.trim() : '';
  
              modalOptions.innerHTML = '';
                  options.forEach(option => {
                  const key = option.querySelector('.cart-item-product-options__option-key');
                  const value = option.querySelector('.cart-item-product-options__option-value');
                  if (key && value) {
                      const optionEl = document.createElement('p');
                      optionEl.innerHTML = `<span>${key.textContent}</span> ${value.textContent}`;
                      modalOptions.appendChild(optionEl);
                  }
              });
  
              modal.classList.add('is-open');
              document.body.style.overflow = 'hidden';
          }
  
          function closeModal() {
              if (modal) {
                  modal.classList.remove('is-open');
                  document.body.style.overflow = '';
                  currentRemoveUrl = null;
              }
          }
  
          document.addEventListener('click', function(e) {
              const removeButton = e.target.closest('[data-cartitem-remove]');
              
              if (removeButton) {
                  e.preventDefault();
                  e.stopPropagation();
                  
                  const cartItem = removeButton.closest('.cart-item');
                  const removeUrl = removeButton.getAttribute('href');
                  
                  if (cartItem && removeUrl) {
                      openModal(cartItem, removeUrl);
                  }
              }
          }, true);
  
          document.addEventListener('keydown', function(e) {
              if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) {
                  closeModal();
              }
          });
      }
      initCartRemoveModal();
  
  
      // Limit próbek w koszyku przy zmianie ilości
      function getSamplesCountFromDom() {
          let count = 0;
          document.querySelectorAll('.cart-item[data-is-sample="true"] [data-quantity-input]').forEach((input) => {
              const val = parseInt(input.value, 10);
              if (!isNaN(val)) {
                  count += val;
              }
          });
          return count;
      }
  
      document.addEventListener('click', function(e) {
          const plusBtn = e.target.closest('[data-quantity-plus]');
          if (!plusBtn) return;
  
          const cartItem = plusBtn.closest('.cart-item');
          if (!cartItem) return;
  
          const isSample = cartItem.dataset.isSample === 'true';
          if (!isSample) return;
  
          const samplesCount = getSamplesCountFromDom();
          if (samplesCount >= 5) {
              e.preventDefault();
              e.stopPropagation();
              CartAddModal.showLimitModal();
          }
      }, true);
  
      //Global
      //checkbox
      document.addEventListener('click', function(e) {
          if (e.target.classList.contains('digi-checkbox-input')) {
              var parent = e.target.closest('.digi-checkbox');
              if (parent) {
                  var checkbox = parent.querySelector('input[type="checkbox"]');
                  if (checkbox) {
                      checkbox.checked = !checkbox.checked;
                      checkbox.dispatchEvent(new Event('change', { bubbles: true }));
                  }
              }
          }
      });
  });
  
  
  
  const CartAddModal = {
    init() {
      this.createModal();
      this.createLimitModal();
      this.bindEvents();
      this.interceptAllAddToCartForms();
    },

    showErrorModal(message) {
      const modal = document.getElementById('cart-add-modal');
      const i18n = getDigiI18n();

      modal.querySelector('.cart-add-modal__image').style.display = 'none';
      modal.querySelector('.cart-add-modal__options').innerHTML = '';
      modal.querySelector('.cart-add-modal__price').textContent = '';
      modal.querySelector('.cart-add-modal__product-name').textContent = '';

      modal.querySelectorAll('.cart-add-modal__title').forEach(el => {
        el.textContent = message || i18n.cartAddSoldOutError;
      });

      const continueBtn = modal.querySelector('[data-action="continue"]');
      if (continueBtn) {
        continueBtn.textContent = i18n.refreshPage || 'Odśwież stronę';
        continueBtn.dataset.action = 'refresh';
      }

      const gotoCartBtn = modal.querySelector('[data-action="goto-cart"]');
      if (gotoCartBtn) gotoCartBtn.style.display = 'none';

      modal.classList.add('is-open', 'is-error');
      document.body.style.overflow = 'hidden';
    },

    createModal() {
      const i18n = getDigiI18n();
      const modalHTML = `
        <div id="cart-add-modal" class="cart-add-modal">
          <div class="cart-add-modal__overlay"></div>
          <div class="cart-add-modal__content">
            <h3 class="cart-add-modal__title title-mobile">${i18n.productAddedToCart}</h3>
            <button class="cart-add-modal__close" aria-label="${i18n.close}">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M6.70757 5.29341C6.51897 5.11125 6.26636 5.01045 6.00417 5.01273C5.74197 5.01501 5.49116 5.12018 5.30575 5.30559C5.12034 5.491 5.01517 5.74181 5.0129 6.00401C5.01062 6.2662 5.11141 6.5188 5.29357 6.70741L10.5866 12.0004L5.29357 17.2934C5.19806 17.3857 5.12188 17.496 5.06947 17.618C5.01706 17.74 4.98947 17.8712 4.98832 18.004C4.98717 18.1368 5.01247 18.2685 5.06275 18.3914C5.11303 18.5143 5.18728 18.6259 5.28117 18.7198C5.37507 18.8137 5.48672 18.8879 5.60962 18.9382C5.73251 18.9885 5.86419 19.0138 5.99697 19.0127C6.12975 19.0115 6.26097 18.9839 6.38297 18.9315C6.50498 18.8791 6.61532 18.8029 6.70757 18.7074L12.0006 13.4144L17.2936 18.7074C17.4822 18.8896 17.7348 18.9904 17.997 18.9881C18.2592 18.9858 18.51 18.8806 18.6954 18.6952C18.8808 18.5098 18.986 18.259 18.9882 17.9968C18.9905 17.7346 18.8897 17.482 18.7076 17.2934L13.4146 12.0004L18.7076 6.70741C18.8897 6.5188 18.9905 6.2662 18.9882 6.00401C18.986 5.74181 18.8808 5.491 18.6954 5.30559C18.51 5.12018 18.2592 5.01501 17.997 5.01273C17.7348 5.01045 17.4822 5.11125 17.2936 5.29341L12.0006 10.5864L6.70757 5.29341Z" fill="#222222"></path>
              </svg>
            </button>
            
            <div class="cart-add-modal__product">
              <div class="cart-add-modal__image">
                <img src="" alt="">
              </div>
              <div class="cart-add-modal__details">
                <h3 class="cart-add-modal__title">${i18n.productAddedToCart}</h3>
                <h4 class="cart-add-modal__product-name"></h4>
                <p class="cart-add-modal__price"></p>
                <div class="cart-add-modal__options"></div>
                <div class="cart-add-modal__buttons">
                  <button class="cart-add-modal__button cart-add-modal__button--secondary btn-primary btn-md" data-action="continue">
                    ${i18n.continueShopping}
                  </button>
                  <button class="cart-add-modal__button cart-add-modal__button--primary btn-ghost btn-md" data-action="goto-cart">
                    ${i18n.goToCart}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      `;
      
      document.body.insertAdjacentHTML('beforeend', modalHTML);
    },
  
    createLimitModal() {
      const i18n = getDigiI18n();
      const limitModalHTML = `
        <div id="cart-limit-modal" class="cart-limit-modal">
          <div class="cart-limit-modal__overlay"></div>
          <div class="cart-limit-modal__content">
            <button class="cart-limit-modal__close" aria-label="${i18n.close}">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M6.70757 5.29341C6.51897 5.11125 6.26636 5.01045 6.00417 5.01273C5.74197 5.01501 5.49116 5.12018 5.30575 5.30559C5.12034 5.491 5.01517 5.74181 5.0129 6.00401C5.01062 6.2662 5.11141 6.5188 5.29357 6.70741L10.5866 12.0004L5.29357 17.2934C5.19806 17.3857 5.12188 17.496 5.06947 17.618C5.01706 17.74 4.98947 17.8712 4.98832 18.004C4.98717 18.1368 5.01247 18.2685 5.06275 18.3914C5.11303 18.5143 5.18728 18.6259 5.28117 18.7198C5.37507 18.8137 5.48672 18.8879 5.60962 18.9382C5.73251 18.9885 5.86419 19.0138 5.99697 19.0127C6.12975 19.0115 6.26097 18.9839 6.38297 18.9315C6.50498 18.8791 6.61532 18.8029 6.70757 18.7074L12.0006 13.4144L17.2936 18.7074C17.4822 18.8896 17.7348 18.9904 17.997 18.9881C18.2592 18.9858 18.51 18.8806 18.6954 18.6952C18.8808 18.5098 18.986 18.259 18.9882 17.9968C18.9905 17.7346 18.8897 17.482 18.7076 17.2934L13.4146 12.0004L18.7076 6.70741C18.8897 6.5188 18.9905 6.2662 18.9882 6.00401C18.986 5.74181 18.8808 5.491 18.6954 5.30559C18.51 5.12018 18.2592 5.01501 17.997 5.01273C17.7348 5.01045 17.4822 5.11125 17.2936 5.29341L12.0006 10.5864L6.70757 5.29341Z" fill="#222222"></path>
              </svg>
            </button>
            <h3 class="cart-limit-modal__title">${i18n.samplesLimitReached}</h3>
            <p class="cart-limit-modal__message">${i18n.samplesLimitMessage}</p>
            <p class="cart-limit-modal__note">${i18n.samplesLimitNote}</p>
            <button class="cart-limit-modal__button btn-primary btn-md" data-action="goto-cart">${i18n.goToCart}</button>
          </div>
        </div>
      `;
      
      document.body.insertAdjacentHTML('beforeend', limitModalHTML);
    },
  
    interceptAllAddToCartForms() {
      const forms = document.querySelectorAll('form[action="/cart/add"]');
      forms.forEach(form => {
        const submitButton = form.querySelector('button[type="submit"], input[type="submit"], [name="add"]');
        
        if (submitButton) {
          submitButton.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            this.handleAddToCart(form);
            return false;
          }, true);
        }
  
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          this.handleAddToCart(form);
          return false;
        }, true);
      });
    },
  
    bindEvents() {
      document.addEventListener('submit', (e) => {
        if (e.target.matches('form[action="/cart/add"]')) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          this.handleAddToCart(e.target);
          return false;
        }
      }, true);
  
      document.addEventListener('click', (e) => {
        if (e.target.matches('form[action="/cart/add"] button[type="submit"], form[action="/cart/add"] input[type="submit"], form[action="/cart/add"] [name="add"]')) {
          console.log("matches handleAddToCart");
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          const form = e.target.closest('form');
          if (form) {
            this.handleAddToCart(form);
          }
          return false;
        }
      }, true);
  
      document.addEventListener('click', (e) => {
        if (e.target.closest('.cart-add-modal__close') || 
            e.target.classList.contains('cart-add-modal__overlay') ||
            e.target.dataset.action === 'continue') {
          this.closeModal();
        }
        
        if (e.target.closest('.cart-limit-modal__close') || 
            e.target.classList.contains('cart-limit-modal__overlay')) {
          this.closeLimitModal();
        }
        
        if (e.target.dataset.action === 'goto-cart') {
          const i18n = getDigiI18n();
          window.location.href = i18n.cartUrl;
        }

        if (e.target.dataset.action === 'refresh') {
          window.location.reload();
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeModal();
          this.closeLimitModal();
        }
      });
    },
  
      async checkSamplesLimit() {
          try {
              const response = await fetch('/cart.js');
              const cart = await response.json();
              
              let samplesCount = 0;
              
              cart.items.forEach(item => {
  
                  if (item.properties && item.properties._is_sample === 'true') {
                      samplesCount += item.quantity;
                  }
              });
              
              return samplesCount;
          } catch (error) {
              console.error(getDigiI18n().samplesCheckError, error);
              return 0;
          }
      },
  
      async isProductSample(form) {
          return form.dataset.isSample === 'true';
      },
  
    async handleAddToCart(form) {
      try {
        const isSample = await this.isProductSample(form);
        
        if (isSample) {
          const samplesCount = await this.checkSamplesLimit();
          
          if (samplesCount >= 5) {
            this.showLimitModal();
            return;
          }
        }
        
        const formData = new FormData(form);
        
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        
        if (!response.ok) {
          throw new Error(getDigiI18n().cartAddFailed);
        }
        
        const productData = await response.json();
        
        this.showModal(productData);
        this.updateCartCount();
        
      } catch (error) {
        const i18n = getDigiI18n();
        console.error(i18n.errorLabel, error);
        //alert(i18n.cartAddErrorAlert);
      }
    },
  
    showModal(productData) {
      const modal = document.getElementById('cart-add-modal');

      const i18n = getDigiI18n();
      modal.classList.remove('is-error');
      modal.querySelectorAll('.cart-add-modal__title').forEach(el => {
        el.textContent = i18n.productAddedToCart;
      });
      modal.querySelector('.cart-add-modal__image').style.display = '';
      const gotoCartBtn = modal.querySelector('[data-action="goto-cart"]');
      if (gotoCartBtn) gotoCartBtn.style.display = '';
      const refreshBtn = modal.querySelector('[data-action="refresh"]');
      if (refreshBtn) {
        refreshBtn.textContent = i18n.continueShopping;
        refreshBtn.dataset.action = 'continue';
      }
      
      let imageUrl = '';
      if (productData.featured_image) {
        imageUrl = typeof productData.featured_image === 'string' 
          ? productData.featured_image 
          : productData.featured_image.url;
      } else if (productData.image) {
        imageUrl = typeof productData.image === 'string' 
          ? productData.image 
          : productData.image.url;
      }
      
      modal.querySelector('.cart-add-modal__image img').src = imageUrl;
      modal.querySelector('.cart-add-modal__image img').alt = productData.product_title;
      modal.querySelector('.cart-add-modal__product-name').textContent = productData.product_title;
      modal.querySelector('.cart-add-modal__price').textContent = this.formatMoney(productData.price);
      
      let optionsHTML = '';
      if (productData.options_with_values && productData.options_with_values.length > 0) {
        optionsHTML = productData.options_with_values
          .map(option => `<p><span>${option.name}:</span> ${option.value}</p>`)
          .join('');
      }
      modal.querySelector('.cart-add-modal__options').innerHTML = optionsHTML;
      
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },
  
    showLimitModal() {
      const modal = document.getElementById('cart-limit-modal');
      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    },
  
    closeModal() {
      const modal = document.getElementById('cart-add-modal');
      modal.classList.remove('is-open', 'is-error');
      document.body.style.overflow = '';

      modal.querySelector('.cart-add-modal__image').style.display = '';
      const gotoCartBtn = modal.querySelector('[data-action="goto-cart"]');
      if (gotoCartBtn) gotoCartBtn.style.display = '';

      const refreshBtn = modal.querySelector('[data-action="refresh"]');
      if (refreshBtn) {
        refreshBtn.textContent = getDigiI18n().continueShopping;
        refreshBtn.dataset.action = 'continue';
      }
    },
  
    closeLimitModal() {
      const modal = document.getElementById('cart-limit-modal');
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    },
  
    formatMoney(cents) {
      const i18n = getDigiI18n();
      const amount = (cents / 100).toFixed(2);
      return amount.replace('.', ',') + i18n.currencySuffix;
    },
  
    async updateCartCount() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        const cartCountElement = document.querySelector('[data-header-cart-count]');
        
        if (cartCountElement) {
          if (cart.item_count > 0) {
            cartCountElement.textContent = cart.item_count;
            cartCountElement.classList.add('visible');
            cartCountElement.setAttribute('data-header-cart-count', cart.item_count);
          } else {
            cartCountElement.textContent = '';
            cartCountElement.classList.remove('visible');
            cartCountElement.setAttribute('data-header-cart-count', '');
          }
        }
        
        const oldCartCountElements = document.querySelectorAll('.cart-count');
        oldCartCountElements.forEach(el => {
          el.textContent = cart.item_count;
        });
        
      } catch (error) {
        console.error(getDigiI18n().cartCountError, error);
      }
    }
  };
  
  document.addEventListener('DOMContentLoaded', () => {
    CartAddModal.init();
  });
  
  
  
  
  
  class ProductSwatchOverride {
    constructor() {
      this.observer = null;
      this.fabricSamples = {};
      this.init();
    }
  
    init() {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup());
      } else {
        this.setup();
      }
    }
  
    async setup() {
      await this.loadFabricSamples();
      this.updateVariantName();
      this.applyFabricImages();
      this.initMutationObserver();
      this.initClickHandler();
    }
  
      async loadFabricSamples() {
          try {
              let allProducts = [];
              let page = 1;
              let hasMoreProducts = true;
  
              while (hasMoreProducts) {
                  const response = await fetch(`/collections/probki-tkanin/products.json?limit=250&page=${page}`);
                  const data = await response.json();
                  
                  if (data.products && data.products.length > 0) {
                      allProducts = allProducts.concat(data.products);
                      page++;
                      
                      if (data.products.length < 250) {
                          hasMoreProducts = false;
                      }
                  } else {
                      hasMoreProducts = false;
                  }
              }
  
              allProducts.forEach(product => {
                  const normalizedTitle = product.title.toUpperCase().trim();
                  this.fabricSamples[normalizedTitle] = {
                  title: product.title,
                  image: product.images[0]?.src || ''
                  };
              });
  
              console.log('this.fabricSamples', this.fabricSamples);
          } catch (error) {
              console.error('Error loading fabric samples:', error);
          }
      }
  
    applyFabricImages() {
      const materialOption = document.querySelector('div[option-name="Materiał"]');
      if (!materialOption) return;
  
      const swatchButtons = materialOption.querySelectorAll('.swatch-button');
      
      swatchButtons.forEach(button => {
        const titleSpan = button.querySelector('.swatch-button-title-text span[swatch-inside="true"]');
        if (!titleSpan) return;
  
        const rawText = titleSpan.textContent.trim();
        const fabricName = rawText.replace(/\s*\(.*?\)\s*/g, '').trim().toUpperCase();
        
        const fabricData = this.fabricSamples[fabricName];
        if (fabricData && fabricData.image) {
          button.style.backgroundImage = `url(${fabricData.image})`;
          button.style.backgroundSize = 'cover';
          button.style.backgroundPosition = 'center';
          button.classList.add('digi-custom-material-button');
        }
      });
    }
  
    updateVariantName() {
      this.updateColorVariant();
      this.updateMaterialVariant();
    }
  
    updateColorVariant() {
      const colorOption = document.querySelector('div[option-name="Kolor"]');
      
      if (!colorOption) return;
      
      const swatchOptionName = colorOption.querySelector('span.swatch-option-name');
      
      if (!swatchOptionName) return;
      
      const selectedSwatch = colorOption.querySelector('.swatch-selected p[swatch-inside="true"]');
      
      if (!selectedSwatch) return;
      
      const variantText = selectedSwatch.textContent.trim();
      
      let variantNameSpan = swatchOptionName.nextElementSibling;
      
      if (!variantNameSpan || !variantNameSpan.classList.contains('swatch-variant-name')) {
        variantNameSpan = document.createElement('span');
        variantNameSpan.className = 'swatch-variant-name';
        swatchOptionName.after(variantNameSpan);
      }
      
      variantNameSpan.textContent = ' ' + variantText;
      variantNameSpan.classList.add('visible');
    }
  
    updateMaterialVariant() {
      const materialOption = document.querySelector('div[option-name="Materiał"]');
      
      if (!materialOption) return;
      
      const swatchOptionName = materialOption.querySelector('span.swatch-option-name');
      
      if (!swatchOptionName) return;
      
      const selectedSwatch = materialOption.querySelector('.swatch-selected .swatch-button-title-text span[swatch-inside="true"]');
      
      if (!selectedSwatch) return;
      
      const rawText = selectedSwatch.textContent.trim();
      const variantText = rawText.replace(/\s*\(.*?\)\s*/g, '').trim().toUpperCase();
      
      let variantNameSpan = swatchOptionName.nextElementSibling;
      
      if (!variantNameSpan || !variantNameSpan.classList.contains('swatch-variant-name')) {
        variantNameSpan = document.createElement('span');
        variantNameSpan.className = 'swatch-variant-name';
        swatchOptionName.after(variantNameSpan);
      }
      
      variantNameSpan.textContent = ' ' + variantText;
      variantNameSpan.classList.add('visible');
    }
  
    initMutationObserver() {
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.addedNodes.length) {
            const swatchAdded = Array.from(mutation.addedNodes).some(node => 
              node.nodeType === 1 && (
                node.classList?.contains('swatch-single') || 
                node.querySelector?.('.swatch-single')
              )
            );
            
            if (swatchAdded) {
              this.updateVariantName();
              this.applyFabricImages();
            }
          }
        });
      });
  
      const swatchContainer = document.querySelector('#swatch-option2, #swatch-option3') || document.body;
      this.observer.observe(swatchContainer.parentElement || document.body, {
        childList: true,
        subtree: true
      });
    }
  
    initClickHandler() {
      document.addEventListener('click', (e) => {
          const swatchItem = e.target.closest('.swatch-view-item');
  
          if (swatchItem) {
              const swatchVariantNames = document.querySelectorAll('.swatch-variant-name');
              if(swatchVariantNames.length > 0) {
                  swatchVariantNames.forEach(element => {
                      element.classList.remove('visible');
                  });
              }
  
              setTimeout(() => {
                  this.updateVariantName();
              }, 50);
          }
      });
    }
  
    destroy() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }
  new ProductSwatchOverride();
  
  
  
  class TrustMateFooter {
    constructor(container) {
      if (!container) {
        document.querySelectorAll('.footer-trustmate-container, .footer-trustmate-containter').forEach((el) => new TrustMateFooter(el));
        return;
      }
  
      this.container = container;
      this.widget = container.nextElementSibling;
      this.summarySpan = container.querySelector('span');
      if (!this.widget?.classList.contains('footer-trustmate') || !this.summarySpan) return;
      this.init();
    }
  
    getData() {
      const gradeEl = this.widget.querySelector('.tm-dodo2__grade');
      const rating = gradeEl ? gradeEl.textContent.trim() : '5.0';
  
      const countEl =
        this.widget.querySelector('.tm-dodo2__text.tm-score-platforms[data-reviews]') ||
        this.widget.querySelector('[data-tm-reviews-count]');
      const count = countEl
        ? parseInt(countEl.getAttribute('data-reviews') || countEl.getAttribute('data-tm-reviews-count'), 10)
        : null;
  
      if (count == null || isNaN(count)) return null;
      return { rating, count };
    }
  
    updateSummary() {
      const data = this.getData();
      if (!data) return false;
      this.summarySpan.textContent = `${data.rating}/5.0 (${data.count} opinii)`;
      return true;
    }
  
    waitForWidget() {
      if (this.updateSummary()) return;
      const observer = new MutationObserver(() => {
        if (this.updateSummary()) observer.disconnect();
      });
      observer.observe(this.widget, { childList: true, subtree: true });
      setTimeout(() => {
        this.updateSummary();
        observer.disconnect();
      }, 3000);
    }
  
    bindClick() {
      this.container.addEventListener('click', () => {
        const trigger = this.widget.querySelector('.tm-dialog-open');
        if (trigger) trigger.click();
      });
    }
  
    init() {
      this.waitForWidget();
      this.bindClick();
    }
  }
  new TrustMateFooter();
  
  
  
  
  
  
  
  
  
  
  
  (function () {
    'use strict';
  
    const DIMENSION_TITLES = [
      'Wysokość',
      'Szerokość',
      'Głębokość',
      'Height',
      'Width',
      'Depth'
    ];
    const DESKTOP_BREAKPOINT = 859;
    const DEBUG_DIMENSION_FILTER = false;
    function log() { if (DEBUG_DIMENSION_FILTER && typeof console !== 'undefined' && console.log) console.log.apply(console, ['[DimFilter]'].concat(Array.prototype.slice.call(arguments))); }
    let instances = [];
  
    function parseNumber(v) {
      const n = parseInt(v, 10);
      return isNaN(n) ? 0 : n;
    }
  
    function isDimensionGroup(groupEl) {
      const titleEl = groupEl.querySelector('.collection-filters__filter-title');
      const title = titleEl ? titleEl.textContent.trim() : '';
      return DIMENSION_TITLES.indexOf(title) !== -1;
    }
  
    function buildApplyUrl() {
      log('buildApplyUrl start, instances:', instances.length);
      const params = new URLSearchParams(window.location.search);
      const path = window.location.pathname;
      const preserved = {};
      for (let i = 0; i < instances.length; i++) {
        const pn = instances[i].paramName;
        if (!(pn in preserved)) preserved[pn] = params.getAll(pn);
        params.delete(pn);
      }
      log('preserved from URL', preserved);
      var paramNames = [];
      var seen = {};
      for (var p = 0; p < instances.length; p++) {
        var pn = instances[p].paramName;
        if (!seen[pn]) { seen[pn] = true; paramNames.push(pn); }
      }
      for (var pi = 0; pi < paramNames.length; pi++) {
        var paramName = paramNames[pi];
        var candidates = instances.filter(function(inst) { return inst.paramName === paramName; });
        if (instances.length > 3) candidates = candidates.filter(function(inst) { return !inst.wrapper || inst.wrapper.offsetParent !== null; });
        var preservedArr = preserved[paramName] || [];
        var preservedMin = preservedArr.length ? Math.min.apply(null, preservedArr.map(parseNumber)) : null;
        var preservedMax = preservedArr.length ? Math.max.apply(null, preservedArr.map(parseNumber)) : null;
        var inst = null;
        for (var c = 0; c < candidates.length; c++) {
          var candidateRange = candidates[c].getCurrentRangeFromUI();
          if (candidateRange && preservedMin != null && preservedMax != null && (candidateRange.min !== preservedMin || candidateRange.max !== preservedMax)) {
            inst = candidates[c];
            log(paramName, 'use edited instance range', candidateRange.min, '-', candidateRange.max, '(preserved was', preservedMin, '-', preservedMax + ')');
            break;
          }
        }
        if (!inst) inst = candidates[0];
        if (!inst) {
          if (preserved[paramName] && preserved[paramName].length) {
            log(paramName, 'no visible instance, using preserved');
            for (var k = 0; k < preserved[paramName].length; k++) params.append(paramName, preserved[paramName][k]);
          }
          continue;
        }
        const range = inst.getCurrentRangeFromUI();
        const fullMin = inst.values[0];
        const fullMax = inst.values[inst.values.length - 1];
        const isNarrowRange = range && (range.min !== fullMin || range.max !== fullMax);
        log(inst.paramName, 'range:', range, 'fullMin:', fullMin, 'fullMax:', fullMax, 'isNarrowRange:', isNarrowRange);
        if (isNarrowRange) {
          const sel = inst.getSelectedParams();
          log(inst.paramName, 'sel values count:', sel ? sel.values.length : 0);
          if (sel && sel.values.length) {
            for (let k = 0; k < sel.values.length; k++) params.append(sel.paramName, sel.values[k]);
          }
        } else if (preserved[paramName] && preserved[paramName].length) {
          log(inst.paramName, 'using preserved, count:', preserved[paramName].length);
          for (let k = 0; k < preserved[paramName].length; k++) {
            params.append(paramName, preserved[paramName][k]);
          }
        } else {
          log(inst.paramName, 'no range + no preserved, skip');
        }
      }
      const query = params.toString();
      const out = path + (query ? '?' + query : '');
      log('buildApplyUrl result:', out);
      return out;
    }
  
    function bindApplyButton() {
      const applyBtn = document.getElementById('filterApplyBtn');
      if (!applyBtn) return;
      applyBtn.addEventListener('click', function (e) {
        log('Apply button clicked, instances:', instances.length);
        if (instances.length === 0) { log('no instances, abort'); return; }
        e.preventDefault();
        e.stopImmediatePropagation();
        window.location.href = buildApplyUrl();
      }, true);
    }
  
    class DimensionFilterRange {
      constructor(container) {
        if (!container) {
          const groups = document.querySelectorAll('.collection-filters__filter-group');
          for (let i = 0; i < groups.length; i++) {
            if (isDimensionGroup(groups[i])) {
              const inst = new DimensionFilterRange(groups[i]);
              if (inst.paramName) instances.push(inst);
            }
          }
          log('DimensionFilterRange: found', instances.length, 'instances', instances.map(function(i){ return i.paramName; }));
          bindApplyButton();
          return;
        }
  
        this.groupEl = container;
        this.paramName = null;
        this.isEnglish = false;
        this.values = [];
        this.rangeMin = null;
        this.rangeMax = null;
        this.wrapper = null;
        this.inputMin = null;
        this.inputMax = null;
        this.sliderMin = null;
        this.sliderMax = null;
        this.progressEl = null;
        this.listEl = null;
        this.itemLinks = [];
        this.actionsEl = null;
        this.init();
      }
  
      getValuesFromList() {
        const list = this.groupEl.querySelector('[data-filter-group-list]');
        if (!list) return null;
        const links = list.querySelectorAll('.js-filter-link[data-name][data-value]');
        if (!links.length) return null;
        const paramName = links[0].getAttribute('data-name');
        const values = [];
        for (let i = 0; i < links.length; i++) {
          values.push(parseNumber(links[i].getAttribute('data-value')));
        }
        values.sort((a, b) => a - b);
        return { paramName, values };
      }
  
      buildRangeUI(min, max) {
        const fromLabel = this.isEnglish ? 'from' : 'od';
        const toLabel = this.isEnglish ? 'to' : 'do';
        const clearLabel = this.isEnglish ? 'Clear' : 'Wyczyść';
        const confirmLabel = this.isEnglish ? 'Apply' : 'Zatwierdź';
  
        const wrapper = document.createElement('div');
        wrapper.className = 'collection-filters__dimension-range';
        wrapper.setAttribute('data-dimension-range', '');
  
        const rangeBlock = document.createElement('div');
        rangeBlock.className = 'collection-filters__filter collection-filters__filter-range';
        rangeBlock.setAttribute('data-filter-group-range', '');
        rangeBlock.innerHTML =
          '<div class="collection-filters__filter-range--from">' +
            '<div class="start">' + fromLabel + '</div>' +
            '<input class="collection-filters__filter-range-input form-field-input" type="number" data-dimension-input-min placeholder="' + min + '" min="' + min + '" max="' + max + '">' +
            '<span class="collection-filters__filter-range-currency">cm</span>' +
          '</div>' +
          '<div class="collection-filters__filter-range--to">' +
            '<div class="start">' + toLabel + '</div>' +
            '<input class="collection-filters__filter-range-input form-field-input" type="number" data-dimension-input-max placeholder="' + max + '" min="' + min + '" max="' + max + '">' +
            '<span class="collection-filters__filter-range-currency">cm</span>' +
          '</div>';
        wrapper.appendChild(rangeBlock);
  
        const sliderWrap = document.createElement('div');
        sliderWrap.className = 'filter-range-slider';
        sliderWrap.innerHTML =
          '<div class="filter-range-slider__track"></div>' +
          '<div class="filter-range-slider__progress" data-dimension-progress></div>' +
          '<input type="range" class="filter-range-slider__input filter-range-slider__input--min" data-dimension-slider-min min="' + min + '" max="' + max + '" value="' + min + '">' +
          '<input type="range" class="filter-range-slider__input filter-range-slider__input--max" data-dimension-slider-max min="' + min + '" max="' + max + '" value="' + max + '">';
        wrapper.appendChild(sliderWrap);
  
        const actionsEl = document.createElement('div');
        actionsEl.className = 'dimension-range-actions';
        actionsEl.style.display = 'none';
        actionsEl.style.marginTop = '8px';
        actionsEl.style.gap = '8px';
        actionsEl.style.flexWrap = 'wrap';
  
        const clearBtn = document.createElement('button');
        clearBtn.type = 'button';
        clearBtn.className = 'dimension-range-clear btn-outline btn-sm';
        clearBtn.textContent = clearLabel;
  
        const confirmBtn = document.createElement('button');
        confirmBtn.type = 'button';
        confirmBtn.className = 'dimension-range-confirm btn-primary btn-md';
        confirmBtn.textContent = confirmLabel;
  
        actionsEl.appendChild(clearBtn);
        actionsEl.appendChild(confirmBtn);
        wrapper.appendChild(actionsEl);
  
        this.wrapper = wrapper;
        this.actionsEl = actionsEl;
        this.inputMin = wrapper.querySelector('[data-dimension-input-min]');
        this.inputMax = wrapper.querySelector('[data-dimension-input-max]');
        this.sliderMin = wrapper.querySelector('[data-dimension-slider-min]');
        this.sliderMax = wrapper.querySelector('[data-dimension-slider-max]');
        this.progressEl = wrapper.querySelector('[data-dimension-progress]');
  
        const showActions = () => {
          if (this.actionsEl) this.actionsEl.style.display = 'flex';
        };
        const hideActions = () => {
          if (this.actionsEl) this.actionsEl.style.display = 'none';
        };
  
        const syncFromSliders = () => {
          let vMin = parseNumber(this.sliderMin.value);
          let vMax = parseNumber(this.sliderMax.value);
          if (vMin > vMax) { vMin = vMax; this.sliderMin.value = vMin; }
          if (vMax < vMin) { vMax = vMin; this.sliderMax.value = vMax; }
          this.inputMin.value = vMin;
          this.inputMax.value = vMax;
          this.rangeMin = vMin;
          this.rangeMax = vMax;
          this.updateProgress();
          this.syncList();
          showActions();
        };
  
        const syncFromInputs = () => {
          let vMin = parseNumber(this.inputMin.value);
          let vMax = parseNumber(this.inputMax.value);
          vMin = Math.max(min, Math.min(max, vMin));
          vMax = Math.max(min, Math.min(max, vMax));
          if (vMin > vMax) vMin = vMax;
          if (vMax < vMin) vMax = vMin;
          this.inputMin.value = vMin;
          this.inputMax.value = vMax;
          this.sliderMin.value = vMin;
          this.sliderMax.value = vMax;
          this.rangeMin = vMin;
          this.rangeMax = vMax;
          this.updateProgress();
          this.syncList();
          showActions();
        };
  
        const clearRange = () => {
          this.rangeMin = null;
          this.rangeMax = null;
          this.inputMin.value = '';
          this.inputMax.value = '';
          this.sliderMin.value = min;
          this.sliderMax.value = max;
          this.updateProgress();
          this.syncList();
          hideActions();
        };
  
        this.sliderMin.addEventListener('input', syncFromSliders);
        this.sliderMax.addEventListener('input', syncFromSliders);
        this.inputMin.addEventListener('change', syncFromInputs);
        this.inputMax.addEventListener('change', syncFromInputs);
  
        clearBtn.addEventListener('click', clearRange);
  
        confirmBtn.addEventListener('click', () => {
          log('Zatwierdź (per-filter) clicked');
          window.location.href = buildApplyUrl();
        });
  
        return wrapper;
      }
  
      updateProgress() {
        if (!this.progressEl || this.values.length === 0 || this.rangeMin == null || this.rangeMax == null) return;
        const minVal = this.values[0];
        const maxVal = this.values[this.values.length - 1];
        const range = maxVal - minVal || 1;
        const left = ((this.rangeMin - minVal) / range) * 100;
        const width = ((this.rangeMax - this.rangeMin) / range) * 100;
        this.progressEl.style.left = left + '%';
        this.progressEl.style.width = width + '%';
      }
  
      getValuesInRange() {
        if (this.rangeMin == null || this.rangeMax == null) return [];
        const result = [];
        for (let i = 0; i < this.values.length; i++) {
          if (this.values[i] >= this.rangeMin && this.values[i] <= this.rangeMax) {
            result.push(this.values[i]);
          }
        }
        return result;
      }
  
      getCurrentRangeFromUI() {
        var lo = this.values[0];
        var hi = this.values[this.values.length - 1];
        if (lo == null || hi == null) return null;
        var minR = this.rangeMin;
        var maxR = this.rangeMax;
        if (this.sliderMin && this.sliderMax) {
          var vMin = parseNumber(this.sliderMin.value);
          var vMax = parseNumber(this.sliderMax.value);
          if (!isNaN(vMin) && !isNaN(vMax)) {
            minR = Math.max(lo, Math.min(hi, vMin));
            maxR = Math.min(hi, Math.max(lo, vMax));
            if (minR > maxR) minR = maxR;
          }
        }
        if (this.inputMin && this.inputMax && (minR == null || maxR == null)) {
          var iMin = parseNumber(this.inputMin.value);
          var iMax = parseNumber(this.inputMax.value);
          if (!isNaN(iMin) && !isNaN(iMax)) {
            minR = minR != null ? minR : Math.max(lo, Math.min(hi, iMin));
            maxR = maxR != null ? maxR : Math.min(hi, Math.max(lo, iMax));
          }
        }
        if (minR == null && this.rangeMin != null) minR = this.rangeMin;
        if (maxR == null && this.rangeMax != null) maxR = this.rangeMax;
        var out = (minR != null && maxR != null) ? { min: minR, max: maxR } : null;
        if (DEBUG_DIMENSION_FILTER && this.paramName) log('getCurrentRangeFromUI', this.paramName, '->', out, 'slider:', this.sliderMin && this.sliderMax ? this.sliderMin.value + '-' + this.sliderMax.value : 'n/a');
        return out;
      }
  
      getEffectiveRange() {
        var minR = this.rangeMin;
        var maxR = this.rangeMax;
        if (this.inputMin && this.inputMax && this.values.length) {
          var minInput = parseNumber(this.inputMin.value);
          var maxInput = parseNumber(this.inputMax.value);
          var lo = this.values[0];
          var hi = this.values[this.values.length - 1];
          if (!isNaN(minInput) && !isNaN(maxInput) && (minInput > 0 || maxInput > 0)) {
            minR = Math.max(lo, Math.min(hi, minInput));
            maxR = Math.min(hi, Math.max(lo, maxInput));
          }
        }
        return { min: minR, max: maxR };
      }
  
      syncList() {
        var effective = this.getEffectiveRange();
        var minR = effective.min;
        var maxR = effective.max;
        if (minR == null || maxR == null) return;
        var inRange = [];
        for (var i = 0; i < this.values.length; i++) {
          if (this.values[i] >= minR && this.values[i] <= maxR) inRange.push(this.values[i]);
        }
        const inRangeSet = {};
        for (let i = 0; i < inRange.length; i++) inRangeSet[inRange[i]] = true;
  
        for (let j = 0; j < this.itemLinks.length; j++) {
          const link = this.itemLinks[j];
          const value = parseNumber(link.getAttribute('data-value'));
          const item = link.closest('.collection-filters__filter-list-item');
          const isInRange = inRangeSet[value];
          const checkbox = link.querySelector('.checkmark');
          const paths = checkbox ? checkbox.querySelectorAll('path') : [];
  
          if (isInRange) {
            item.classList.add('collection-filters__filter-list-item--active');
            link.setAttribute('data-filter-active', '');
            if (checkbox) {
              checkbox.setAttribute('data-animation-state', 'checked');
              paths.forEach(p => p.setAttribute('data-animation-state', 'checked'));
            }
          } else {
            item.classList.remove('collection-filters__filter-list-item--active');
            link.removeAttribute('data-filter-active');
            if (checkbox) {
              checkbox.setAttribute('data-animation-state', 'unchecked');
              paths.forEach(p => p.setAttribute('data-animation-state', 'unchecked'));
            }
          }
        }
      }
  
      getSelectedParams() {
        var range = this.getCurrentRangeFromUI();
        var values;
        if (range) {
          values = [];
          for (var i = 0; i < this.values.length; i++) {
            if (this.values[i] >= range.min && this.values[i] <= range.max) values.push(this.values[i]);
          }
        } else {
          values = this.getValuesInRange();
        }
        if (values.length === 0) return null;
        return { paramName: this.paramName, values: values.map(String) };
      }
  
      init() {
          if (!isDimensionGroup(this.groupEl)) return;
  
          const titleEl = this.groupEl.querySelector('.collection-filters__filter-title');
          const title = titleEl ? titleEl.textContent.trim() : '';
          this.isEnglish = title === 'Height [cm]' || title === 'Width [cm]' || title === 'Depth [cm]';
          const data = this.getValuesFromList();
          if (!data || data.values.length === 0) return;
  
          this.paramName = data.paramName;
          this.values = data.values;
          this.rangeMin = null;
          this.rangeMax = null;
          this.listEl = this.groupEl.querySelector('[data-filter-group-list]');
          this.itemLinks = this.listEl ? this.listEl.querySelectorAll('.js-filter-link[data-name][data-value]') : [];
  
          const content = this.groupEl.querySelector('[data-accordion-content]');
          if (!content) return;
  
          const rangeUI = this.buildRangeUI(this.values[0], this.values[this.values.length - 1]);
          content.insertBefore(rangeUI, content.firstChild);
  
          if (this.listEl) {
            const optionItems = this.listEl.querySelectorAll('.collection-filters__filter-list-item');
            optionItems.forEach(function(li) { li.style.display = 'none'; });
          }
  
          const params = new URLSearchParams(window.location.search);
          const valuesForParam = params.getAll(this.paramName);
          log('init from URL paramName:', this.paramName, 'valuesFromUrl:', valuesForParam.length, valuesForParam.slice(0, 5), valuesForParam.length > 5 ? '...' : '');
          if (valuesForParam.length > 0) {
              const nums = valuesForParam.map(v => parseNumber(v)).filter(n => this.values.includes(n));
              log('init nums in this.values:', nums.length, 'min/max would be:', nums.length ? Math.min(...nums) + '-' + Math.max(...nums) : 'n/a');
              if (nums.length > 0) {
                const minVal = Math.min(...nums);
                const maxVal = Math.max(...nums);
                this.rangeMin = minVal;
                this.rangeMax = maxVal;
                this.inputMin.value = minVal;
                this.inputMax.value = maxVal;
                this.sliderMin.value = minVal;
                this.sliderMax.value = maxVal;
                this.updateProgress();
                this.syncList();
                  if (this.actionsEl) this.actionsEl.style.display = 'flex';
                log('init set sliders to', minVal, maxVal, 'for', this.paramName);
              } else {
                log('init no nums in this.values - param name mismatch or values not in list?');
              }
          } else {
            log('init no URL values for', this.paramName, 'search:', window.location.search ? window.location.search.slice(0, 80) : '(empty)');
          }
      }
    }
  
    if (typeof window !== 'undefined') {
      window.DimensionFilterRange = DimensionFilterRange;
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => new DimensionFilterRange());
    } else {
      new DimensionFilterRange();
    }
  })();
  
  
  
  /* Override Shopify functions */
  function waitForShopify(maxAttempts = 200) {
    if (maxAttempts <= 0) {
      console.error('Shopify API nie załadowało się w ciągu 10 sekund');
      return;
    }

    if (typeof Shopify !== 'undefined' && Shopify.onItemAdded) {

      Shopify.onItemAdded = function(line_item) {
        if (typeof CartAddModal !== 'undefined' && CartAddModal.showModal) {
          CartAddModal.showModal(line_item);
          if (CartAddModal.updateCartCount) {
            CartAddModal.updateCartCount();
          }
        }
      };

      Shopify.onError = function(XMLHttpRequest, textStatus) {
        if (typeof CartAddModal !== 'undefined' && CartAddModal.showErrorModal) {
          CartAddModal.showErrorModal(getDigiI18n().cartAddSoldOutError);
        }
      };

      const originalAddItem = Shopify.addItem;
      Shopify.addItem = function(variant_id, qty, callback) {
        Shopify.addItemFromForm = Shopify.addItemFromForm; 
        return originalAddItem.call(this, variant_id, qty, function(line_item) {
          if (typeof callback === 'function') callback(line_item);
          if (typeof CartAddModal !== 'undefined' && CartAddModal.showModal) {
            CartAddModal.showModal(line_item);
            if (CartAddModal.updateCartCount) CartAddModal.updateCartCount();
          }
        });
      };

      Shopify.onItemAddedFailed = function(errors) {
        if (typeof CartAddModal !== 'undefined' && CartAddModal.showErrorModal) {
          CartAddModal.showErrorModal(getDigiI18n().cartAddSoldOutError);
        }
      };

    } else {
      setTimeout(() => waitForShopify(maxAttempts - 1), 50);
    }
  }
  
  waitForShopify();